import React from 'react';
import './FilterBar.scss';
import isMobile from 'is-mobile';
import { PrimaryButton, DesktopFilterModal } from '../../index';

const FilterBar = ({ categoriesToFilterBy, handleClick, indicator }) => {
    const buttonStyle = {
      color: '#FFF',
      backgroundColor: "#444",
      width: isMobile() ? 'auto' : '125px',
      margin: 5,
      fontFamily: 'Open Sans Light',
      fontWeight: 100,
      fontSize: isMobile() ? '16px' : '22px'
    }

    return (
      <div className='filter-bar'>
        <span> Filter by: </span>
        {
          categoriesToFilterBy && categoriesToFilterBy.length ? (
            categoriesToFilterBy.map(category => {
              const loweredCaseCategory = category.toLowerCase();

              return (
                <PrimaryButton
                  key={loweredCaseCategory}
                  id={loweredCaseCategory}
                  style={buttonStyle}
                  onClick={(e) => handleClick({e},loweredCaseCategory)}
                >
                {category}
                {
                  indicator[loweredCaseCategory] &&
                  <span style={{color: '#16C4AB', display:`${indicator[loweredCaseCategory].length ? 'inline-block': 'none'}`}}>
                    {indicator[loweredCaseCategory].length ? `(${indicator[loweredCaseCategory].length})` : ''}
                  </span>
                }
              </PrimaryButton>
              )
            })
          ) : null
        }
      </div>
    )
}

export default FilterBar;
